// Institute of Design and Innovation (email idi@unm.edu). //

import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'
import Home from '../views/Home.vue'
import Login from '../views/Login.vue'
import Calendar from '../views/Calendar.vue'
import Schedule from '../views/Schedule.vue'
import App from '../App.vue'
import AppointmentTypes from '../views/AppointmentTypes.vue'
import AppointmentType from '../views/AppointmentType.vue'
import Availability from '../views/Availability.vue'
import Users from '../views/Users.vue'
import User from '../views/User.vue'
import Profile from '../views/Profile.vue'
import SystemSettings from '../views/SystemSettings.vue'
import SignedOut from '../views/SignedOut.vue'
import Sponsors from '../views/Sponsors.vue'
import ManageAppointment from '../views/ManageAppointment.vue'
import loginGuard from './loginGuard'
import authGuard from './authGuard'
import OspPermissionValues from '@/models/permissions'
import homeGuard from './homeGuard'
import Reporting from '../views/Reporting.vue'

/**
 * Routes and names
 */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'App',
    component: App,
    beforeEnter: loginGuard,
    children: [
      {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: homeGuard
      },
      {
        path: '/calendar',
        name: 'Calendar',
        component: Calendar,
        beforeEnter: authGuard,
        meta: { requiredPermission: OspPermissionValues.canViewCalendar }
      },
      {
        path: '/appointment-types',
        name: 'AppointmentTypes',
        component: AppointmentTypes
      },
      {
        path: '/appointment-types/:id',
        name: 'AppointmentType',
        component: AppointmentType
      },
      {
        path: '/appointment-types/remove/:id',
        name: 'AppointmentType/remove',
        component: AppointmentType
      },
      {
        path: '/appointment-types/restore/:id',
        name: 'AppointmentType/remove',
        component: AppointmentType
      },
      {
        path: '/availability',
        name: 'Availability',
        component: Availability
      },
      {
        path: '/users',
        name: 'Users',
        component: Users
      },
      {
        path: '/users/:id',
        name: 'User',
        component: User
      },
      {
        path: '/system',
        name: 'system',
        component: SystemSettings
      },
      {
        path: '/profile',
        name: 'Profile',
        component: Profile
      },
      {
        path: '/reporting',
        name: 'reporting',
        component: Reporting
      },
      {
        path: '/sponsors',
        name: 'Sponsors',
        component: Sponsors
      }
    ]
  },
  {
    path: '/login',
    name: 'Login',
    component: Login
  },
  {
    path: '/signed-out',
    name: 'SignedOut',
    component: SignedOut
  },
  {
    path: '/schedule',
    name: 'Schedule',
    component: Schedule,
    beforeEnter: loginGuard
  },
  {
    path: '/manage/:id',
    name: 'Manage',
    component: ManageAppointment
  }
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

export default router
